/*
 * @Author: yzf
 * @Date: 2020-12-01 16:35:09
 * @LastEditTime: 2020-12-01 18:40:13
 * @LastEditors: yzf
 * @Description: 这是文件
 * @FilePath: /alex/Volumes/project/hex/wuwei/src/router/children/other.js
 * @大威天龙,世尊地藏,般若诸佛,般若巴麻空,没有bug
 */
export default {
  '/census': {
    name: 'version',
    meta: {
      'zh-CN': {
        title: '数据查看'
      }
    },
    component: () => import(/* webpackChunkName: "census" */ '../../views/other/census/index.vue')
  },
  '/log': {
    name: 'log',
    meta: {
      'zh-CN': {
        title: '更新日志'
      }
    },
    component: () => import(/* webpackChunkName: "changeLog" */ '../../views/other/changeLog/index.vue')
  },
  '/insert': {
    name: 'log',
    meta: {
      'zh-CN': {
        title: '新增更新日志'
      }
    },
    component: () => import(/* webpackChunkName: "insertLog" */ '../../views/other/changeLog/insert.vue')
  }
}
